<template><div><h1>VUX V2.6.2 released</h1>
<h2><a href="/en/components/checklist.html">Checklist</a></h2>
<ul><li>[feature] Support radio mode(max = 1) #1996</li>
</ul>
<h2><a href="/en/components/picker.html">Picker</a></h2>
<ul><li>[enhance] scroll distance respects html[data-dpr] #1979</li>
</ul>
<h2><a href="/en/components/x-address.html">XAddress</a></h2>
<ul><li>[fix] update address data #2000</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.6.2 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.6.2-126.vue?a3896946